import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Layout, Card } from "antd";
import { URL } from "../00_Nav/url";
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import LayoutFooter from "../00_Nav/layout/layout_footer";
import { PAYOUT_MENU } from "../../store/string";
import "./style.css";

const { Content } = Layout;

const PayoutScreen = () => {
  const navigate = useNavigate();
  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Payout", url: URL.payout },
  ];

  const renderBody = () => {
    return (
      <Row gutter={[20, 20]} style={{ marginTop: 20 }}>
        {PAYOUT_MENU?.map((item) => renderItem({ item }))}
      </Row>
    );
  };

  const renderItem = ({ item }) => {
    const key = item?.key;
    const title = item?.title;
    const icon = item?.icon;
    const route = item?.route;
    return (
      <Col align="center" key={key} xl={4} lg={4} md={8} xs={12}>
        <Card
          className="card-menu-report"
          onClick={() => navigate(`/payout/${route}`)}
        >
          <div style={{ maxWidth: "100%" }}>{icon}</div>
          <div>
            <strong>{title}</strong>
          </div>
        </Card>
      </Col>
    );
  };

  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        {renderBody()}
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default PayoutScreen;
